import { render } from "./QrcodeDropZone.vue?vue&type=template&id=d58a83ac&lang=html&bindings={\"worker\":\"props\",\"onDragOver\":\"options\",\"onDrop\":\"options\",\"processFile\":\"options\",\"processUrl\":\"options\"}"
import script from "./QrcodeDropZone.vue?vue&type=script&lang=js"
export * from "./QrcodeDropZone.vue?vue&type=script&lang=js"
script.render = render

export default script